import { Box, styled, Typography } from "@mui/material";
import { ReactComponent as CarIcon } from "./images/car.svg";
import { ReactComponent as WorldIcon } from "./images/world.svg";
import useFeatureFlag from "hooks/useFeatureFlag";
import theme from "lib/theme";

const BANNER_SURFACE = "#F4EEE2";
const BANNER_BORDER = "#DEB894";

const NEW_BANNER_BODY =
  "Revivn aims to repurpose as much hardware as possible by turning it into items that people can still use, keeping pressure off the landfills and disposal areas and saving the energy that comes with having to dismantle and remanufacture products. A sustainable pickup is net positive for the earth - it contains more items that can be repurposed vs recycled.";

const LEGACY_BANNER_BODY =
  "Revivn aims to repurpose as much hardware as possible by turning it into items that people can still use, keeping pressure off the landfills and saving the energy that comes with having to dismantle and remanufacture products. A sustainable pickup is net positive for the earth - it contains more items that can be repurposed vs pure waste. Laptops and computers tend to be highly repurposable items and help fuel Revivn's mission.";

export default function Banner() {
  const { enabled: newLogisticsPageEnabled, loading: newLogisticsPageLoading } =
    useFeatureFlag("new_logistics_page_enabled");

  const CustomBox = styled(Box)({
    border: `2px solid ${BANNER_BORDER}`,
    backgroundColor: BANNER_SURFACE,
    borderRadius: 7,
    height: "175px",
    display: "flex",
    alignItems: "center",
    gap: 4,
    px: 1,
    mt: 5,
    [theme.breakpoints.down("sm")]: {
      height: "248px",
      paddingLeft: "10px",
      mt: 2,
    },
  });

  if (newLogisticsPageLoading) {
    return null;
  }

  if (newLogisticsPageEnabled) {
    return (
      <CustomBox mt={10}>
        <Box sx={{ p: 0, m: 0, display: { xs: "none", md: "block" }, flexShrink: 0 }}>
          {<WorldIcon style={{ width: "300px", height: "180px" }} />}
        </Box>
        <Box>
          <Typography variant="h4" mt={{ md: 0, xs: 0 }} fontWeight="700">
            Request a pickup
          </Typography>
          <Typography mt={1} fontSize={15}>
            {NEW_BANNER_BODY}
          </Typography>
        </Box>
      </CustomBox>
    );
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 4 }}>
      <Box sx={{ p: 0, m: 0, display: { xs: "none", md: "block" }, flexShrink: 0 }}>{<CarIcon />}</Box>
      <Box>
        <Typography variant="h4" mt={{ md: 0, xs: 0 }} fontWeight="bold">
          Schedule a pickup
        </Typography>
        <Typography mt={1}>{LEGACY_BANNER_BODY}</Typography>
      </Box>
    </Box>
  );
}
